import { Grid } from '@material-ui/core';
import Icon from '../../Icon';
import ToolTip from '@material-ui/core/Tooltip';
import helpers from '../../../helpers';
import { nodeKeysLabel } from "../../../../../../../config/common";
import Handle from '../../Handler';
import './style.css';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import NodeHelperPopup from '../../../../../dialogs/NodeHelperPopup';

const useStyles = makeStyles({
    image: {
        width: 77,
        height: 70,
        display: 'block',
        position: 'relative',
        top: 0,
        left: 0,
        marginTop: 15
    },
    label: {
        textAlign: 'center',
        display: 'block',
        fontSize: 17,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 500,
        position: 'relative',
        color: '#000',
    },
    labelDiv: {
        marginTop: "130px",
        pointerEvents: 'all'
    },
})


export default function Analytics({ props, iconStyle, validations }) {
    const nodeData = props.data != undefined ? props.data : '';
    const title = props?.data?.subType !== undefined && props?.data?.subType !== '' ? nodeKeysLabel[props?.data?.subType] : helpers.nodeKeysLabel[props.type];
    const classes = useStyles()
    
    return (
        <Grid row  id={`node-${props.id}`}>
            {/* <ToolTip title={<>{nodeData?.label}<br/>{`(${title})`}</>} > */}
                <Grid xs={12} container spacing={2} style={{pointerEvents: 'all'}}>
                    {
                        nodeData?.profile ?
                        <div id="edit-profile-button" style={{
                            position: 'absolute', 
                            top: '-5px',
                            right: '-9px',
                            background: 'yellow',
                            borderRadius: '50%',
                            border: '1px solid rgb(0,0,0)',
                            aspectRatio: '1/1',
                            width: '27pt',
                            height: '27pt',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            zIndex: 1000
                        }}>
						    <svg style={{pointerEvents: 'none'}} width="25pt" height="25pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
						     <path d="m65.742 57.867c-4.3242 0-7.875 3.5508-7.875 7.875 0 4.3242 3.5508 7.875 7.875 7.875 4.3242 0 7.875-3.5508 7.875-7.875 0-4.3242-3.5508-7.875-7.875-7.875zm0 3.9375c2.1953 0 3.9375 1.7383 3.9375 3.9375 0 2.1953-1.7383 3.9375-3.9375 3.9375-2.1953 0-3.9375-1.7383-3.9375-3.9375 0-2.1953 1.7383-3.9375 3.9375-3.9375z"/>
						     <path d="m28.348 32.285c-1.082 0.003906-1.957 0.87891-1.9609 1.9609-0.003907 0.52344 0.20312 1.0234 0.57031 1.3945 0.36719 0.37109 0.86719 0.58203 1.3906 0.58203h31.496c0.52344 0 1.0234-0.21094 1.3906-0.58203s0.57422-0.87109 0.57031-1.3945c-0.003907-1.082-0.87891-1.957-1.9609-1.9609z"/>
						     <path d="m40.16 48.035c-1.082 0.003906-1.9609 0.87891-1.9609 1.9609-0.003907 0.51953 0.20312 1.0234 0.57031 1.3945 0.36719 0.37109 0.86719 0.57812 1.3906 0.58203h31.496c0.51953-0.003906 1.0195-0.21094 1.3867-0.58203 0.37109-0.37109 0.57422-0.875 0.57422-1.3945-0.003907-1.082-0.88281-1.957-1.9609-1.9609z"/>
						     <path d="m28.348 63.766c-0.52344 0.003906-1.0234 0.21094-1.3906 0.58203-0.36719 0.37109-0.57422 0.875-0.57031 1.3945 0.003906 1.082 0.87891 1.957 1.9609 1.9609h31.496c1.082-0.003906 1.957-0.87891 1.9609-1.9609 0.003906-0.51953-0.20313-1.0234-0.57031-1.3945s-0.86719-0.57812-1.3906-0.58203z"/>
						     <path d="m65.742 26.387c-4.3242 0-7.875 3.5352-7.875 7.8594 0 4.3242 3.5508 7.875 7.875 7.875 4.3242 0 7.875-3.5508 7.875-7.875 0-4.3242-3.5508-7.8594-7.875-7.8594zm0 3.9375c2.1953 0 3.9375 1.7266 3.9375 3.9219 0 2.1953-1.7383 3.9375-3.9375 3.9375-2.1953 0-3.9375-1.7383-3.9375-3.9375 0-2.1953 1.7383-3.9219 3.9375-3.9219z"/>
						     <path d="m34.262 42.121c4.3242 0 7.875 3.5508 7.875 7.875 0 4.3242-3.5508 7.875-7.875 7.875s-7.875-3.5508-7.875-7.875c0-4.3242 3.5508-7.875 7.875-7.875zm0 3.9375c-2.1953 0-3.9375 1.7383-3.9375 3.9375 0 2.1953 1.7383 3.9375 3.9375 3.9375 2.1953 0 3.9375-1.7383 3.9375-3.9375 0-2.1953-1.7383-3.9375-3.9375-3.9375z"/>
						    </svg>
                        </div>
                        : nodeData.hovered ?
                        <div id="add-profile-button" style={{
                            position: 'absolute', 
                            top: '-5px',
                            right: '-9px',
                            background: 'yellow',
                            borderRadius: '50%',
                            border: '1px solid rgb(0,0,0)',
                            aspectRatio: '1/1',
                            width: '27pt',
                            height: '27pt',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            zIndex: 1000
                        }}>
						    <svg style={{pointerEvents: 'none'}} width="20pt" height="20pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
	 					     <path d="m91 50c0 3.3086-2.6914 6-6 6h-27c-1.1016 0-2 0.89844-2 2v27c0 3.3086-2.6914 6-6 6s-6-2.6914-6-6v-27c0-1.1016-0.89844-2-2-2h-27c-3.3086 0-6-2.6914-6-6s2.6914-6 6-6h27c1.1016 0 2-0.89844 2-2v-27c0-3.3086 2.6914-6 6-6s6 2.6914 6 6v27c0 1.1016 0.89844 2 2 2h27c3.3086 0 6 2.6914 6 6z"/>
	 					    </svg>
                        </div>
                        : null
                    }
                    <Icon icon={props?.data?.icon} metaData={props.data} isCustomIcon={props?.data?.isCustomIcon} defaultIcon={'ide_analytics_default'} style={iconStyle} />
                {nodeData?.showHelper && <NodeHelperPopup nodeData={nodeData} title={title} nodeId={props.id} nodeType={props.type} subType={props?.data?.subType} templateId={props?.templateId} />}
                    
                </Grid>
            {/* </ToolTip> */}

            <Grid item xs={12} className={classes.labelDiv}><span className={classes.label}>{props.data.label}</span></Grid>

            <Handle type="source" position="left" id="left" isValidConnection={validations('target', 'analytics')} node={props}/>
            <Handle type="source" position="right" id="right" node={props}/>
            <Handle type="source" position="top" style={{ marginTop: '-2px' }} id="top" node={props}/>
            <Handle type="source" position="bottom" style={{ marginBottom: '-2px' }} id="bottom" node={props}/>

        </Grid>
    )
}

